import React from "react";
import { Grid } from "@material-ui/core";
import { useTheme } from "@material-ui/styles";
import { BarChart, Bar, Tooltip,XAxis } from "recharts";
import classnames from "classnames";
import { ArrowForward as ArrowForwardIcon } from "@material-ui/icons";

// styles
import useStyles from "./styles";

// components
import Widget from "../../Widget";
import { Typography } from "../../Wrappers";

export default function TileDefault(props) {
  var { product, color, today, yesterday, monthly, weekly, week, isAvg, isRaw, todayRaw, yesterdayRaw, isCurrency } = props;
  var classes = useStyles();
  var theme = useTheme();
  if(today === undefined){
    return (<></>)
  }

  return (
    <Widget header={
      <div>
        <Typography variant="h5">{product}</Typography>
      </div>
    }
    upperTitle >
      
      <Typography variant="h5">{product}</Typography>
      <div className={classes.totalValueContainer}>
        
        <div className={classes.totalValue}>
          <Typography size="xxl" color="text" colorBrightness="secondary">
            {(isCurrency ? `$${today.value}`: today.value)}
          </Typography>
          {getArrow(isRaw === true ? todayRaw.value : today.value, isRaw === true ? yesterdayRaw.value : yesterday.value)}
          <Typography color={"primary"}>
            Today
          </Typography>
        </div>
        <BarChart width={150} height={70} data={week}>
          <Bar
            dataKey="quantity"
            fill={theme.palette[color].main}
            radius={10}
            barSize={10}
          />
          <XAxis type="category" dataKey="dateSubscribed" hide />
          <Tooltip />
        </BarChart>
      </div>
      <div className={classes.bottomStatsContainer}>
        <div className={classnames(classes.statCell, classes.borderRight)}>
          <Grid container alignItems="center">
            <Typography variant="h6">{(isCurrency ? `$${yesterday.value}`: yesterday.value)}</Typography>
            {(isAvg ? getArrow(yesterday.value,weekly.value):<></>)}
          </Grid>
          <Typography size="sm" color="text" colorBrightness="secondary">
            Yesterday
          </Typography>
        </div>
        <div className={classes.statCell}>
          <Grid container alignItems="center">
            <Typography variant="h6">{(isCurrency ? `$${weekly.value}`: weekly.value)}</Typography>
            {(isAvg ? getArrow(weekly.value,monthly.value):<></>)}
          </Grid>
          <Typography size="sm" color="text" colorBrightness="secondary">
            Last 7 days
          </Typography>
        </div>
        <div className={classnames(classes.statCell, classes.borderRight)}>
          <Grid container alignItems="center">
            <Typography variant="h6">
            {(isCurrency ? `$${monthly.value}`: monthly.value)}
            </Typography>
          </Grid>
          <Typography size="sm" color="text" colorBrightness="secondary">
            Last 30 days
          </Typography>
        </div>
      </div>
    </Widget>
  );

  function getArrow(firstValue, valueToCompare) {
    return <ArrowForwardIcon className={(parseFloat(firstValue) > parseFloat(valueToCompare) ? classnames(classes.profitArrow) : firstValue !== valueToCompare ? classnames(classes.profitArrowDanger) : classnames())} />;
  }
}
